// @ts-expect-error TS(7006) FIXME: Parameter 'max' implicitly has an 'any' type.
export const getRandomNumber = (max) => {
  return Math.floor(Math.random() * max)
}

// @ts-expect-error TS(7006) FIXME: Parameter 'min' implicitly has an 'any' type.
export const getRandomNumberFromInterval = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min)
}
